import BaseModel from '../core/BaseModel'
export default class WarrantyRepairProductSnHasServiceSuppliesModel extends BaseModel {
    constructor() {
        super({ 
                name: "warranty_repair_product_sn_has_service_supplies",
                tableName: 'core_warranty_repair_product_sn_has_service_supplies'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            fied_detail: {
                refs: ' warranty_repair_product_sn_has_service_park_id service_pack_service_supplies_id info_service_supplies is_free number discount money_discount total_price',
                display: false
            },
        },)
    }

}